import React from 'react'

type UseKeyListenerOptions = {
  key: string
  callback: () => void
}

const useKeyListener = ({ key, callback }: UseKeyListenerOptions) => {
  const callbackRef = React.useRef(callback)

  React.useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  React.useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === key) {
        if (callbackRef.current && typeof callbackRef.current === 'function') {
          callbackRef.current()
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [key])

  return null
}

export default useKeyListener
